/*
 |-----------------------------------------------------------------------------
 | La fecha de caducidad de una entrega
 |-----------------------------------------------------------------------------
 | Una caducidad no es un instante, es un DÍA DEL CALENDARIO: el estudio piensa
 | «hasta el 31 de marzo», no «hasta las 23:59:59 UTC». Tratarla como instante
 | daba dos fallos que sólo se ven con gente en husos distintos:
 |
 |   1. Mandar `T23:59:59` sin huso lo guardaba como UTC, así que en Lima la
 |      entrega se cerraba a las 18:59 — el diálogo prometía «todo ese día» y
 |      quitaba cinco horas.
 |   2. Pintarla con la zona del navegador hacía que el mismo proyecto pusiera
 |      «8 de agosto» para el estudio y «9 de agosto» para quien lo mirara desde
 |      Europa.
 |
 | Se ancla a Perú, que es el mercado: los precios van en soles, el IGV se
 | desglosa y los comprobantes son de SUNAT. Y no tiene horario de verano, así
 | que el desfase es siempre -05:00 y no hace falta una tabla de husos.
 |
 | El día que haya tenants fuera, esto pasa a ser un campo del estudio y las
 | funciones de este archivo son el único sitio que hay que tocar.
 */

const TIME_ZONE = 'America/Lima'
const UTC_OFFSET = '-05:00'

/** De `AAAA-MM-DD` del formulario al instante en que acaba ese día en Perú. */
export function endOfDayInStudioZone(date: string): string {
  return `${date}T23:59:59${UTC_OFFSET}`
}

/** Del instante guardado al `AAAA-MM-DD` que el estudio eligió. */
export function toStudioDate(iso: string): string {
  // `en-CA` da AAAA-MM-DD, que es justo lo que quiere un `<input type="date">`.
  return new Intl.DateTimeFormat('en-CA', { timeZone: TIME_ZONE }).format(new Date(iso))
}

/** «9 de agosto», siempre el mismo día lo mire quien lo mire. */
export function formatStudioDate(iso: string): string {
  return new Intl.DateTimeFormat('es-PE', {
    day: 'numeric',
    month: 'long',
    timeZone: TIME_ZONE,
  }).format(new Date(iso))
}

/** «9 de agosto, 15:42» — para el acuse, donde la hora es parte del dato. */
export function formatStudioDateTime(iso: string): string {
  return new Intl.DateTimeFormat('es-PE', {
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: TIME_ZONE,
  }).format(new Date(iso))
}
